import { coursePrice, courseFirstTimePrice } from '../utils/stripePrices'

const paymentOptions = [
  {
    id: coursePrice,
    name: 'S.O.S. Course',
    description: 'One Payment of $197',
    sizzle: 'Charged only once',
    price: 197
  },
  {
    id: courseFirstTimePrice,
    name: 'S.O.S. Course',
    description: 'Two Payments of $115 ',
    sizzle: 'Billed another $115 next month',
    price: 115
  }
]

export default paymentOptions
